export const deepLooselyEquals = (a, b) => {
    // eslint-disable-next-line eqeqeq
    if (a == b)
        return true;
    // undefined and null
    if (a == null)
        return false;
    if (b == null)
        return false;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length)
            return false;
        for (let i = a.length - 1; i >= 0; i--) {
            if (!deepLooselyEquals(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    if (Number.isNaN(a) && Number.isNaN(b)) {
        return true;
    }
    if (typeof a === 'object' && typeof b === 'object') {
        const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
        for (const key of keys) {
            if (!deepLooselyEquals(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return false;
};
//# sourceMappingURL=deepLooselyEquals.js.map